import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import performanceStore from './performance';
import TR from './../Trans';

const initialState = {
  isSet: false,
  itemsOnPage: 300,
  totalCount: 0,
  currentPage: 1,
  isWaiting: false,
  isFinished: false,
  singers: null
};

const singerStore = create((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  getSingers: (sessionToken) => {
    set({ currentPage: 1, singers: [], isWaiting: true, isFinished: false });
    MuvikaService.getSingers(sessionToken, get().itemsOnPage, 1)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, singers: null, totalCount: 0, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let singersList = res.data.data.items;
          set({ isSet: true, singers: singersList, totalCount: res.data.data.items_total, isWaiting: false });
          if (singersList.length < get().itemsOnPage) {
            set({ isFinished: true });
          }
        }
      })
      .catch(function () { });
  },
  getSingersMore: (sessionToken) => {
    if (!get().isWaiting) {
      let page = get().currentPage + 1;
      set({ currentPage: page, isWaiting: true });
      MuvikaService.getSingers(sessionToken, get().itemsOnPage, page)
        .then(function (res) {
          if (res.data.error) {
            set({ isSet: false, singers: null, isWaiting: false });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let singers = get().singers;
            let singersMore = res.data.data.items;
            if (singersMore.length == 0) {
              set({ isFinished: true });
            }
            singers = singers.concat(singersMore);
            set({ isSet: true, singers: singers, totalCount: res.data.data.items_total, isWaiting: false });
          }
        })
        .catch(function () { });
    }
  },
  addSingerLocally: (singer) => {
    let singers = get().singers;
    let singerId = singers.findIndex(x => x.id == singer.id);
    if (singerId == -1) {
      if (singers) {
        singers.push(singer);
      } else {
        singers = [singer];
      }
      set({ singers: [...singers] });
    }
  },
  createSinger: (sessionToken, name, gender, email) => {
    //console.log(get().singers)
    MuvikaService.createSinger(sessionToken, name, gender, email)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let singer = res.data.data;
          //console.log(singer)
          let singers = get().singers;
          if (singers) {
            //console.log(singers)
            singers.push(singer);
            //console.log(singers)
            set({ singers: [...singers], totalCount: singers.length });
            messageStore.getState().setMessage(sessionToken, TR.cm_created);
          }
        }
      })
      .catch(function () { });
  },
  deleteSinger: (sessionToken, profileId) => {
    MuvikaService.deleteSinger(sessionToken, profileId)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let singers = get().singers;
          if (singers) {
            let profileIndex = singers.findIndex(x => x.id == profileId);
            if (profileIndex != -1) {
              singers.splice(profileIndex, 1);
              set({ singers: [...singers], totalCount: singers.length });
              performanceStore.getState().getPlayQueue(sessionToken);
              performanceStore.getState().getPlayLists(sessionToken);
              messageStore.getState().setMessage(sessionToken, TR.cm_deleted_big);
            }
          }
        }
      })
      .catch(function () { });
  },
  editSinger: (sessionToken, profileId, name, gender, email) => {
    MuvikaService.editSinger(sessionToken, profileId, name, gender, email)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let singers = get().singers;
          if (singers) {
            let profileIndex = singers.findIndex(x => x.id == profileId);
            if (profileIndex != -1) {
              singers[profileIndex].name = name;
              singers[profileIndex].gender = gender;
              singers[profileIndex].email = email;
              set({ singers: [...singers] });
              performanceStore.getState().editSinger(profileId, name, gender, email);
              messageStore.getState().setMessage(sessionToken, TR.cm_saved);
            }
          }
        }
      })
      .catch(function () { });
  }
}));

export default singerStore;